'use client'

import { useEffect } from 'react'
import { trackCurrentPage, trackPageView } from '../utils/gtm'

/**
 * Hook per il tracking automatico delle pageview
 * @param {string} content_group - Sezione di riferimento della pagina
 * @param {string} [vertical] - Vertical (default: 'LP Dona')
 */
export function usePageTracking(content_group, vertical = 'LP Dona') {
  useEffect(() => {
    if (content_group) {
      trackCurrentPage(content_group, vertical)
    }
  }, [content_group, vertical])
}

/**
 * Hook che fornisce le funzioni di tracking per le pagine
 */
export function useGTMPageTracking() {
  return {
    trackPageView,
    trackCurrentPage,
  }
}
